import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadComprobantesPagos } from '../../../store/slices/configuracionesSlice';
import ComprobantesConfigBody from './ComprobantesConfigBody';

const ComprobantesPagos = (props) => {
  const dispatch = useDispatch();
  const comprobantes = useSelector(state => state.configuraciones.comprobantesPagos.items);
  const loading = useSelector(state => state.configuraciones.comprobantesPagos.loading);
  const onLoad = (empresaId) => dispatch(loadComprobantesPagos(empresaId));
  const {
    empresaId,
    onChangeValue,
    configInicial,
    seleccionarTodos,
    deseleccionarTodos
  } = props;

  return (
    <ComprobantesConfigBody
      comprobantes={comprobantes}
      empresaId={empresaId}
      loading={loading}
      onChangeValue={onChangeValue}
      onLoad={onLoad}
      configInicial={configInicial}
      seleccionarTodos={seleccionarTodos}
      deseleccionarTodos={deseleccionarTodos}
    />
  );
};

export default ComprobantesPagos;